export const getGameRoomUrl = (
  gameNetwork: string,
  gameContractAddress: string
) => `/game/${gameNetwork}-${gameContractAddress}`;
